function kb(item, input) {
  var input = jQuery("#" + input)[0];
  if (document.selection) {
    input.focus();
    range = document.selection.createRange();
    range.text = item;
    range.select();
  } else if (input.selectionStart || input.selectionStart == "0") {
    var startPos = input.selectionStart;
    var endPos = input.selectionEnd;
    var cursorPos = startPos;
    var scrollTop = input.scrollTop;
    var baselength = 0;
    input.value =
      input.value.substring(0, startPos) +
      item +
      input.value.substring(endPos, input.value.length);
    cursorPos += item.length;
    input.focus();
    input.selectionStart = cursorPos;
    input.selectionEnd = cursorPos;
    input.scrollTop = scrollTop;
  } else {
    input.value += item;
    input.focus();
  }

  // Clear the previous timeout if it exists
  if (typeof debounceTimeout !== "undefined") {
    clearTimeout(debounceTimeout);
  }

  // Set a new timeout
  debounceTimeout = setTimeout(function () {
    jQuery(input).change(); // Trigger the change event on the input
  }, 2000); // Adjust the delay as needed

  return false;
}
